import { useQuery } from 'react-query';
import { useToastProvider } from '@qualio/ui-components';
import formTemplateApi from '../api/formTemplate.api';
import { DefaultErrorMessage } from '../displayStrings';
import { isNotFoundError } from '../utils/errorUtils';

export const baseFormTemplateQueryKey = 'formTemplateDetails';
export const useFormTemplateDetails = (
  companyId: number,
  eventTemplateId: number,
  stepId: number | undefined,
  formTemplateId: number,
  enabled = true,
) => {
  const { showToast } = useToastProvider();

  return useQuery(
    [baseFormTemplateQueryKey, companyId, eventTemplateId, formTemplateId],
    () => formTemplateApi.getFormTemplate(companyId, eventTemplateId, stepId!, formTemplateId),
    {
      enabled: enabled && !!stepId,
      // A missing form template is a terminal outcome: don't retry it (react-query defaults to 3),
      // and let the view render the not-found page instead of firing a generic error toast.
      retry: (failureCount, error) => !isNotFoundError(error) && failureCount < 3,
      onError: (error) => {
        if (isNotFoundError(error)) {
          return;
        }
        showToast({
          title: 'Failed to fetch form template details',
          description: DefaultErrorMessage,
          status: 'error',
        });
      },
    },
  );
};
